
import {Component, Input} from '@angular/core';
import {TenantService} from '../../../services/tenant.service';

// Chemin par défaut du logo header VGE. L'image a été extraite du base64
// historique (inline dans le SVG) vers un asset binaire BIT-IDENTIQUE
// (src/assets/images/vge/logo-header.png) : le rendu VGE reste inchangé au
// pixel. Un tenant peut surcharger via `branding.logoPath` ; sans surcharge,
// c'est ce défaut VGE qui est servi.
const LOGO_HEADER_DEFAUT_VGE = 'assets/images/vge/logo-header.png';

@Component({
  selector: 'app-logo',
  standalone: true,
  templateUrl: './logo-partial.html',
  imports: [],
  host: {
    class: 'flex items-center gap-2'
  }
})
export class LogoPartial {
  @Input() logoOnly: boolean = false;
  @Input() dark: boolean = false;
  @Input() auth: boolean = false;
  @Input() size: string = '100%';

  // Source de l'image du logo : `branding.logoPath` du tenant si défini,
  // sinon le défaut VGE (identité). La géométrie SVG (viewBox, pattern,
  // preserveAspectRatio, dimensions, classes) reste strictement inchangée :
  // seule la source de l'image varie, garantissant le rendu VGE au pixel.
  readonly logoSrc: string;

  constructor(private tenantService: TenantService) {
    this.logoSrc = this.tenantService.branding.logoPath || LOGO_HEADER_DEFAUT_VGE;
  }
}
